import { render, staticRenderFns } from "./taskCommentsTab.vue?vue&type=template&id=51101083&scoped=true&"
import script from "./taskCommentsTab.vue?vue&type=script&lang=js&"
export * from "./taskCommentsTab.vue?vue&type=script&lang=js&"
import style0 from "./taskCommentsTab.vue?vue&type=style&index=0&id=51101083&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51101083",
  null
  
)

export default component.exports